import home  from "./modules/home"
import common from "./modules/common"
import news from "./modules/news"
import mushroom from "./modules/mushroom"

const apis = {
    home,
    common,
    news,
    mushroom
}
export default apis


// WEBPACK FOOTER //
// ./src/api/index.js